import { Link } from "react-router-dom";
import { MaskedLines, FadeUp } from "./Reveal";

/** Shared editorial layout for the legal pages. */
export const LegalPage = ({ overline, title, updated, children, testId }) => (
  <div className="pt-16 lg:pt-20" data-testid={testId}>
    <section className="max-w-[900px] mx-auto px-6 lg:px-12 pt-20 lg:pt-28 pb-10">
      <FadeUp><p className="overline mb-8 text-crimson">{overline}</p></FadeUp>
      <h1 className="font-serif font-light tracking-tighter leading-[0.9] text-vellum text-[clamp(2.5rem,7vw,5rem)]">
        <MaskedLines lines={[title]} />
      </h1>
      <FadeUp delay={0.2}>
        <p className="mt-8 font-mono text-xs uppercase tracking-[0.2em] text-vellum-faint">Last updated {updated}</p>
      </FadeUp>
    </section>
    <section className="max-w-[900px] mx-auto px-6 lg:px-12 pb-28 space-y-12">{children}</section>
  </div>
);

export const Clause = ({ heading, children }) => (
  <FadeUp>
    <div className="border-t border-line pt-8">
      <h2 className="font-serif text-2xl lg:text-3xl font-light text-vellum mb-4">{heading}</h2>
      <div className="space-y-4 text-vellum-muted leading-relaxed">{children}</div>
    </div>
  </FadeUp>
);

export const LegalFooterNote = ({ children }) => (
  <FadeUp>
    <p className="border-t border-line pt-8 text-sm text-vellum-faint leading-relaxed">
      {children} <Link to="/" className="text-brass link-underline">Back to the library</Link>.
    </p>
  </FadeUp>
);
